import Header from '../../components/header/header';
import UserInfoForm from '../../components/userInfoForm/userInfoForm';
import './userInfo.css';

const UserInfo = () => {
    return (
        <div className="user-info">
            <Header></Header>
            <UserInfoForm></UserInfoForm>
        </div>
    );
};

export default UserInfo;